<template>
    <div class="step">
        <div :class="['step-item', currentStepIndex === index + 1 ? 'active-item' : '']" v-for="(item, index) of config" :key="index">
            <span class="stem-index">{{index + 1}}</span>{{item}}
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        config: {
            type: Array
        },
        currentStepIndex: {
            default: 1
        }
    },
};
</script>
<style lang="scss" scoped>
.step {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    .step-item {
        flex: 1;
        font-size: 12px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        color: rgba(26, 41, 64, 1);
        background: rgba(241, 244, 249, 1);
        .stem-index {
            display: inline-block;
            width: 16px;
            height: 16px;
            line-height: 16px;
            background: rgba(232, 235, 241, 1);
            color: #1a2940;
            text-align: center;
            border-radius: 50%;
            margin-right: 4px;
        }
        &.active-item {
            color:rgba(255,255,255,1);
            background: rgba(10, 211, 167, 1);
            .stem-index {
                background: rgba(255, 255, 255, 1);
                color:rgba(10, 211, 167, 1);
            }
        }
    }
}
</style>